export default "/1.b21474a38790e82f9764d6976eff4071.png";